import { Col, Divider } from "@commonlibs";
import styled, { css } from "styled-components";
import { MainDrawerRootProps } from "./MainDrawer.types";

export const MainDrawerRoot = styled.div<MainDrawerRootProps>(
    ({ open, theme }) => css`
        position: fixed;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: ${open ? theme.zIndex.modal : -2};
        ${theme.breakpoints.up("maxPageWidth")} {
            max-width: ${theme.breakpoints.values.maxPageWidth}px;
        }
    `,
);

export const MainDrawerWrapper = styled(Col)(({ theme }) => {
    return css`
        background: linear-gradient(180deg, #7575e5, #3b3b73);
        width: 100%;
        max-width: ${theme.breakpoints.values.mini}px;
        position: fixed;
        top: 0;
        z-index: ${theme.zIndex.modal};
        height: 100%;
        overflow-y: auto hidden;
        ${theme.breakpoints.up("maxPageWidth")} {
            position: absolute;
            height: 100vh;
        }
        @media screen and (orientation: landscape) and (max-width: ${theme.breakpoints.values.sm}px) {
            max-width: unset;
            width: 100vw;
            position: fixed;
            left: 0;
            height: 100%;
        }
    `;
});

export const DrawerDivider = styled(Divider)(
    ({ theme }) => css`
        &.Divider {
            background-color: ${theme.palette.overlays[0][20]};
        }
    `,
);
